import restaurant from './restaurant';
import chain from './chain';
import kiosk from './kiosk';
import website from './website';
import websiteAccessKey from './websiteAccessKey';
import menuCategory from './menuCategory';
import menuItem from './menuItem';
import loyaltyGroup from './loyaltyGroup';
import campaign from './campaign';
import marketingCampaign from './marketingCampaign';
import benefit from './benefit';
import issue from './issue';
import discount from './discount';
import panelUser from './panelUser';
import company from './company';
import budgetGroup from './budgetGroup';
import orderSubscription from './orderSubscription';
import invoice from './invoice';
import deliveryInfo from './deliveryInfo';
import paymentPermission from './paymentPermission';
import brand from './brand';
import itemInstance from './itemInstance';

export default (entityType, entity = {}) => {
    entity = entity || {};
    switch (entityType) {
        case 'restaurant':
        case 'restaurantConfig':
            return restaurant(entity);
        case 'chain':
            return chain(entity);
        case 'marketingCampaign':
            return marketingCampaign(entity);
        case 'menuCategory':
            return menuCategory(entity);
        case 'menuItem':
            return menuItem(entity);
        case 'loyaltyGroup':
            return loyaltyGroup(entity);
        case 'campaign':
            return campaign(entity);
        case 'benefit':
            return benefit(entity);
        case 'issue':
            return issue(entity);
        case 'discount':
            return discount(entity);
        case 'panelUser':
            return panelUser(entity);
        case 'company':
            return company(entity);
        case 'budgetGroup':
            return budgetGroup(entity);
        case 'orderSubscription':
            return orderSubscription(entity);
        case 'invoice':
            return invoice(entity);
        case 'deliveryInfo':
            return deliveryInfo(entity);
        case 'paymentPermission':
            return paymentPermission(entity);
        case 'kiosk':
            return kiosk(entity);
        case 'website':
            return website(entity);
        case 'websiteAccessKey':
            return websiteAccessKey(entity);
        case 'brand':
            return brand(entity);
        case 'itemInstance':
            return itemInstance(entity);
        case 'loyaltyProgramRestaurant':
        case 'member':
        case 'budgerCard':
            return entity;
        default:
            return null;
    }
};
